import { apiClient } from "@/api/softphone_api.js";

const COMPANY_TYPIFICATION_URL = "api/admin/company_typification/";
const CALL_LOG_URL = "api/fxCrm/CrmCallLog/";
const TYPIFICATION_URL = "api/fxCrm/CrmTypification/";

export const getCompanyTypification = (companyId, client = apiClient) =>
  client.get(COMPANY_TYPIFICATION_URL, {
    params: companyId ? { company_id: companyId } : {},
  });

export const setCompanyTypification = (enabled, companyId, client = apiClient) =>
  client.patch(COMPANY_TYPIFICATION_URL, {
    typification_enabled: enabled,
    ...(companyId ? { company_id: companyId } : {}),
  });

// `itx_management` evita que el back adivine la gestión por teléfono.
export const checkCallLog = ({ callId, phone, itxManagement }) =>
  apiClient.get(`${CALL_LOG_URL}check/`, {
    params: {
      phone,
      ...(callId ? { call_id: callId } : {}),
      ...(itxManagement ? { itx_management: itxManagement } : {}),
    },
  });

export const finishCallLog = (payload) =>
  apiClient.post(`${CALL_LOG_URL}finish/`, payload);

// `callLogId` es el id de la llamada, no el de la gestión.
export const updateCallLogTypification = (callLogId, typification) =>
  apiClient.patch(`${CALL_LOG_URL}${callLogId}/`, { typification });

export const getCallTypifications = async () => {
  const { data } = await apiClient.get(TYPIFICATION_URL, {
    params: { action_type: "call" },
  });
  return Array.isArray(data) ? data : data?.results || [];
};
